'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import globalConfig from '../settings/config';

const MapFooterContainer = (props) => {
  const selectedCollection = props.selectedCollection;

  const collections = globalConfig.collections;

  let classes = '';
  let displayName = '';

  for (let key in collections) {
    let collection = collections[key];
    if (collection.hasOwnProperty('name')) {
      let collName = collection.name;
      if (collName == selectedCollection) {
        classes = `collection-name ${collection.styleType}`;
        displayName = collection.displayName;
      }
    }
  }

  return (
    <div className="map-footer">
      <a href="#hazard-reductions-list_wrapper">
        View all events in table view
      </a>
      <a href="#" className={classes}>
        {displayName}
      </a>
    </div>
  );
};

export default MapFooterContainer;
